import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const OOPSModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7', 'Module 8'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Variables', path: '/oop-m1-s1' },
      { name: 'DATA TYPES', path: '/oop-m1-s2' },
      { name: 'OPERATORS , OPERATOR PRECEDENCE AND EXPRESSIONS  ', path: '/oop-m1-s3' },
      { name: 'TYPE CONVERSIONS IN C', path: '/oop-m1-s4' },
      { name: 'I/O statements', path: '/oop-m1-s5' },
      { name: 'DIFFERENT TYEPS OF BRANCHING STATEMENTS IN C', path: '/oop-m1-s6' },
      { name: 'DIFFERENT TYPES OF LOOPING STATEMENTS IN C', path: '/oop-m1-s7' },
      { name: 'Summary', path: '/oop-m1-s8' },
    ],
    'Module 2': [
      { name: 'One dimensional Array  and Two dimensional array', path: '/oop-m2-s1' },
      { name: 'Strings', path: '/oop-m2-s2' },
      { name: 'Functions', path: '/oop-m2-s3' },
      { name: 'StorageClasses', path: '/oop-m2-s4' },
      { name: 'Summary', path: '/oop-m2-s5' },
    ],
    'Module 3': [
      { name: 'Pointers', path: '/oop-m3-s1' },
      { name: 'DYNAMIC MEMORY ALLOCATION', path: '/oop-m3-s2' },
      { name: 'POINTERS AND ARRAYS', path: '/oop-m3-s3' },
      { name: 'POINTERS AND FUNCTIONS', path: '/oop-m3-s4' },
      { name: 'Summary', path: '/oop-m3-s5' },
    ],
    'Module 4': [
      { name: 'Structures', path: '/oop-m4-s1' },
    ],
    'Module 5': [
      { name: 'Features of OOP', path: '/oop-m5-s1' },
      { name: 'Classes and Objects: "this" Pointer', path: '/oop-m5-s2' },
      { name: 'Constructors and Destructors', path: '/oop-m5-s3' },
      { name: 'Friend Function and Class', path: '/oop-m5-s4' },
      { name: 'Static Member Functions and Objects', path: '/oop-m5-s5' },
      { name: 'Inline Functions', path: '/oop-m5-s6' },
      { name: 'Function with Default Arguments & Functions with Objects and Arguments', path: '/oop-m5-s7' },
    ],
    'Module 6': [
      { name: 'INHERITANCE', path: '/oop-m6-s1' },
    ],
    'Module 7': [
      { name: 'Function Overloading & Operator Overloading', path: '/oop-m7-s1' },
      { name: 'DYNAMIC POLYMORPHISM VIRTUAL FUNCTIONS PURE VIRTUAL FUNCTIONS AND ABSTRACT CLASSES', path: '/oop-m7-s2' },
      { name: 'Module Summary', path: '/oop-m7-s3' },
    ],
    'Module 8': [
      { name: 'Function Templates & STL', path: '/oop-m8-s1' },
      { name: 'Module Summary', path: '/oop-m8-s2' },
    ]
  };

  const [openModule, setOpenModule] = useState(null);
  const allSubtopics = getAllSubtopics(subtopicsData);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Object - Oriented Programming </h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module].map((topic, index) => (
                  <li key={index}>
                    <span>{topic.name}</span>
                    <Link
                      to={topic.path}
                      className="article-link"
                      state={{ subtopics: allSubtopics, subjectPath: '/subject-OOPSModules' }}
                    >
                      <FontAwesomeIcon icon={faFileAlt} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OOPSModules;
